<template>
  <VContainer>
    <h1 class="font-bold text-xl mb-8">{{ $t('Set new password') }}</h1>
    <div class="py-10">
      <p class="p-2 bg-gray-100 shadow-sm text-gray-900 rounded" v-for="message in data" :key="message">
        {{ message }}
      </p>
    </div>
    <FormKit type="form" class="pb-4 md:p-6 mt-10 md:border md:border-neutral-200 rounded-md" :errors="errors" @submit="submitForm">
      <FormKit
        name="password1"
        v-model="form.password"
        :label="t('Password')"
        type="password"
        :errors="data.psdata?.password"
        :rules="['required']"
      />
      <PasswordStrengthIndicator
        v-if="form.password"
        :password="form.password"
      />
      <FormKit
        name="password2"
        v-model="form.repeatPassword"
        :label="t('Confirm Password')"
        type="password"
        :errors="data.psdata?.password"
        :rules="['required']"
      />
    </FormKit>
    <NuxtLink :to="localePath('/login')" class="text-sm text-neutral-600 hover:text-neutral-700">
      &leftarrow; {{ t('Back to login') }}
    </NuxtLink>
  </VContainer>
</template>

<script setup lang="ts">
import { useSdk } from '~/sdk';

const { t } = useI18n();
const localePath = useLocalePath();
const route = useRoute();
const data = ref<any>({});
const errors = ref<string[]>([]);
const form = reactive({
  password: '',
  repeatPassword: '',
});

async function submitForm() {
  let res = await useSdk().commerce.resetPasswordEnter({
    reset_token: route.query.reset_token as string,
    passwd: form.password,
    confirmation: form.repeatPassword,
    id_customer: route.query.id_customer as string,
    token: route.query.token as string,
  });

  if (!res.success) {
    errors.value = res.psdata?.length ? res.psdata : res.message ? [res.message] : [];
    return;
  }

  data.value = res.psdata?.length ? res.psdata : res.message ? [res.message] : [];
}
</script>
